<template>
  <div class="dropdown" v-click-outside="closeMenu">
    <div
      class="dropdown__button"
      @click.stop="toggleMenu"
    >
      <m-button
        :type="buttonType"
        :size="buttonSize"
        :disabled="buttonDisabled"
        :label="buttonLabel"
        :icon="buttonIcon"
        :icon-size="buttonIconSize"
      />
    </div>

    <div
      v-if="isMenuOpen"
      class="dropdown__menu"
    >
      <div
        class="dropdown__item"
        v-for="(value, idx) in values"
        :key="`${idx}-item`"
        @click.stop="onItemClick(value)"
      >
        {{ value.name }}
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'm-dropdown',
  props: {
    buttonType: {
      type: String,
      default: 'primary',
    },
    buttonSize: {
      type: String,
      default: 'medium',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: [String, Boolean],
      default: '',
    },
    buttonIcon: {
      type: [String, Boolean],
      default: null,
    },
    buttonIconSize: {
      type: String,
      default: 'medium',
    },
    values: {
      type: Array,
      required: true, // createSection|Article editSection|Article deleteSection|Article
    },
    item: {
      type: [Object, Array, String]},
      default: null,
  },
  data() {
    return {
      isMenuOpen: false,
    }
  },
  computed: {
    menuClass() {
      return [
        !this.isMenuOpen && 'dropdown__menu_hide'
      ]
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    onItemClick(value) {
      this.$emit('select', value.type, this.item)

      this.closeMenu()
    },
    closeMenu() {
      this.isMenuOpen = false
    },
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  &__button {

  }

  &__menu {
    padding: 3px;
    position: absolute;
    right: 0;
    background: $white;
    color: black;
    border: 1px solid rgba($color: $dark-gray-old, $alpha: .4);
    border-radius: 10px;
    min-width: 300px;
    max-height: 700px;
    z-index: 10;

    &_hide {
      display: none;
    }
  }

  &__item {
    transition: all 0.25s;
    padding: 5px;
    border-radius: 10px;

    &:hover {
      color: $primary-old;
      background: $light-gray-old;
      cursor: pointer;
    }
  }
}
</style>